var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Col, Row } from "react-bootstrap";
import EdModal from "@frameworks/web/components/generic/edModal";
import InputField from "@frameworks/web/components/generic/inputField";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import Timmer from "@frameworks/web/components/generic/Timmer";
import { integerExp } from "@frameworks/web/utils/regex";
var Verificationpopup = function (props) {
    var _a = __read(React.useState(true), 2), show = _a[0], setShow = _a[1];
    var _b = __read(React.useState(""), 2), otp = _b[0], setOtp = _b[1];
    var _c = __read(React.useState(false), 2), otpTimer = _c[0], setOtpTimer = _c[1];
    var _d = __read(React.useState(false), 2), invalidMsg = _d[0], setInvalidMsg = _d[1];
    var setInvalid = function (resp) {
        setInvalidMsg(resp);
        if (resp !== null && resp !== undefined && resp)
            props === null || props === void 0 ? void 0 : props.setOtpSuccessStatus(false);
    };
    return (React.createElement("div", { className: "message-popup-family" },
        React.createElement(EdModal, { show: props === null || props === void 0 ? void 0 : props.showPopup, setShow: function (e) {
                props === null || props === void 0 ? void 0 : props.setShowPopup(e);
            }, modalTitle: "addfamily-popup-verification sales-client commonmodal modal-md add-contact ", size: "modal-md modal-dialog-centered", title: props.title, showFooter: false, closeDropdown: function () { }, stopClossOnOutsideClick: true }, React.createElement(React.Fragment, null,
            React.createElement(Row, null,
                React.createElement(Col, { lg: 12, className: "px-15" },
                    React.createElement("label", { className: "DMSanN_14_400 txt_primaryGrey" }, props.isMobile ? "Mobile" : "Email"),
                    React.createElement("span", { className: "displayvalue-data" }, props.isMobile ? props.mobileNo : props.emailId)),
                React.createElement(Col, { lg: 12, className: "mt-20  pt-3 pb-3 px-15" },
                    React.createElement("label", { className: "DMSanN_14_400 txt_primaryGrey" }, "Enter OTP"),
                    React.createElement("div", { className: "add-family-grid" },
                        React.createElement("div", { className: "text-right" },
                            React.createElement(InputField, { className: "mgt-10 RobotoM_16_500 txt_blackOne1 family-memeber-txt", placeholderClassName: "", defaultValue: otp, maxLength: 6, onChangeEvent: function (e) {
                                    setInvalidMsg(function (invalidMsg) {
                                        invalidMsg = false;
                                        return invalidMsg;
                                    });
                                    props === null || props === void 0 ? void 0 : props.setOtpSuccessStatus(false);
                                    setOtp(e.target.value);
                                }, type: "text", pattern: integerExp, onBlur: function () { }, onKeyPress: function (keyEvent) {
                                    setInvalidMsg(function (invalidMsg) {
                                        invalidMsg = false;
                                        return invalidMsg;
                                    });
                                    if (keyEvent.key >= "0" && keyEvent.key <= "9") {
                                        return true;
                                    }
                                    else {
                                        if (keyEvent.key !== "Backspace" &&
                                            keyEvent.key !== "Enter")
                                            keyEvent.preventDefault();
                                    }
                                } }),
                            otpTimer && (React.createElement(React.Fragment, null,
                                invalidMsg && (React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                                    React.createElement("div", { className: "DMSansNormal_12_400 text-right txt_redDark mt-2" }, "Invalid Otp"))),
                                !invalidMsg && (props === null || props === void 0 ? void 0 : props.otpSuccessStatus) && (React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                                    React.createElement("span", { className: "DMSansNormal_12_400 text-right txt_green mt-2" }, "OTP Sent Successfully!"))))),
                            React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                                otpTimer && (React.createElement("div", { className: "d-flex align-items-center timer-block DMSansNormal_12_400 mt-2" },
                                    React.createElement("i", { className: "edel-icon-timeout-holding me-1" }),
                                    " ",
                                    "Resend OTP in",
                                    " ",
                                    React.createElement(Timmer, { min: 0, sec: 30, onTimerClose: function () {
                                            setOtpTimer(false);
                                        } }))),
                                invalidMsg && !otpTimer && (React.createElement("div", { className: "DMSansNormal_12_400 text-right txt_redDark mt-2" }, "Invalid Otp")),
                                !invalidMsg && !otpTimer && (props === null || props === void 0 ? void 0 : props.otpSuccessStatus) && (React.createElement("span", { className: "DMSansNormal_12_400 text-right txt_green mt-2" }, "OTP Sent Successfully!")),
                                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Resend OTP", className: "text-right resend-btn", disabled: otpTimer, type: "button", onClick: function () {
                                        setOtpTimer(true);
                                        setOtp("");
                                        setInvalid(false);
                                        props.resendOtp(props === null || props === void 0 ? void 0 : props.isMobile);
                                    } }))))),
                React.createElement(Col, { lg: 12 },
                    React.createElement("div", null,
                        React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Submit", className: "w-100", disabled: !(otp && otp.length >= 6) || invalidMsg, onClick: function () {
                                if (otp && otp.length >= 6)
                                    props.verifyOtp(otp, props === null || props === void 0 ? void 0 : props.isMobile, props === null || props === void 0 ? void 0 : props.selectedIndex, setInvalid);
                            } }))))))));
};
export default Verificationpopup;
